import React from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  ModalCloseButton,
  Button,
  VStack,
  HStack,
  Heading,
  Text,
  List,
  ListItem,
  ListIcon,
  Checkbox,
  Divider,
  Badge,
  useColorModeValue,
} from "@chakra-ui/react";
import { FaCheckCircle, FaInfoCircle } from "react-icons/fa";

const WhatsNewModal = ({
  isOpen,
  onClose,
  version,
  releaseDate,
  features,
  dontShowAgain,
  onDontShowAgainChange,
}) => {
  const badgeBg = useColorModeValue("blue.100", "blue.900");
  const badgeColor = useColorModeValue("blue.800", "blue.100");

  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered size="lg">
      <ModalOverlay backdropFilter="blur(5px)" />
      <ModalContent borderRadius="2xl">
        <ModalHeader>
          <HStack spacing={3} mb={2}>
            <FaInfoCircle />
            <Heading size="md">What's New in Novatra</Heading>
          </HStack>
          <Badge
            bg={badgeBg}
            color={badgeColor}
            px={2}
            py={1}
            borderRadius="full"
            fontSize="sm"
          >
            Version {version}
          </Badge>
          {releaseDate && (
            <Text fontSize="sm" color="gray.500" mt={1}>
              Released {releaseDate}
            </Text>
          )}
        </ModalHeader>
        <ModalCloseButton />

        <ModalBody>
          <VStack align="start" spacing={4}>
            <Text>Here's what's new in this release:</Text>

            <List spacing={3} width="100%">
              {features.map((feature, index) => (
                <ListItem
                  key={index}
                  p={3}
                  borderRadius="md"
                  borderWidth="1px"
                  borderColor={useColorModeValue("gray.200", "gray.700")}
                  _hover={{
                    bg: useColorModeValue("gray.50", "gray.800"),
                    transform: "translateX(2px)",
                    transition: "all 0.2s",
                  }}
                >
                  <HStack align="start" spacing={3}>
                    <ListIcon
                      as={FaCheckCircle}
                      color={useColorModeValue("green.500", "green.300")}
                      mt={1}
                    />
                    <VStack align="start" spacing={0}>
                      <Text fontWeight="medium">{feature.title}</Text>
                      {feature.description && (
                        <Text fontSize="sm" color="gray.500">
                          {feature.description}
                        </Text>
                      )}
                    </VStack>
                  </HStack>
                </ListItem>
              ))}
            </List>

            <Divider />

            <Checkbox
              isChecked={dontShowAgain}
              onChange={(e) => onDontShowAgainChange(e.target.checked)}
            >
              Don't show this again
            </Checkbox>
          </VStack>
        </ModalBody>

        <ModalFooter>
          <Button colorScheme="blue" onClick={onClose}>
            Got it
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default WhatsNewModal;
